import MainHeader from "../components/MainHeader";
import { matchPath, useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { LicenceType } from "../models/globalTypes";
import { useGetNotifications } from "../operations/queries/getNotifications";
import { useDismissNotifications } from "../operations/mutations/dismissNotifications";
import { useAppContext } from "../hooks/useAppContext";

const MainHeaderContainer = () => {
  const { myOrganizations, myRegisters, currentOrgUser } = useAppContext();
  const { user } = useCurrentUser();
  const { orgName } = useParams<{ orgName?: string }>();
  const { projectName } = useParams<{ projectName: string }>();
  const { registerTitle } = useParams<{ registerTitle: string }>();
  const { data: notificationsData, refetch: refetchNotifications } = useGetNotifications(user?.id ?? "");
  const { mutate: dismissNotifications } = useDismissNotifications();
  const [activeOrg, setActiveOrg] = useState<string>(orgName ? orgName : "");

  const location = useLocation();
  const history = useHistory();

  const isSettingPathActive = !!matchPath(location.pathname, "/settings");

  const handleOrgChange = useCallback(
    (name: string): void => {
      setActiveOrg(name);
      history.push(`/${name}`);
    },
    [setActiveOrg, history],
  );

  const handleRegisterChange = (projName: string, title: string): void => {
    history.push(`/${orgName}/projects/${projName}/registers/${title}`);
  };

  useEffect(() => {
    if (activeOrg === "" && myOrganizations && myOrganizations.length > 0 && !isSettingPathActive) {
      handleOrgChange(myOrganizations[0].name);
    }
  }, [activeOrg, myOrganizations, isSettingPathActive, handleOrgChange]);

  const isCurrentPageIsView = useRouteMatch({
    path: "/:orgName/projects/:projectName/registers/:registerTitle/view",
    exact: true,
    strict: false,
  });

  useEffect(() => {
    if (!isCurrentPageIsView) {
      if (currentOrgUser && orgName && projectName && registerTitle) {
        if (currentOrgUser.licence?.type === LicenceType.VIEWER) {
          history.push(`/${orgName}/projects/${projectName}/registers/${registerTitle}/view`);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrgUser, orgName, projectName, registerTitle]);

  const handleDismissNotifications = (ids: string[]) => {
    dismissNotifications({
      variables: {
        notificationIds: ids,
      },
    }).then(() => {
      refetchNotifications && refetchNotifications();
    });
  };

  return (
    <MainHeader
      organizations={myOrganizations}
      myRegisters={myRegisters}
      orgName={orgName}
      projectName={projectName}
      registerTitle={registerTitle}
      onOrgChange={handleOrgChange}
      onRegisterChange={handleRegisterChange}
      onHomeClick={() => (orgName ? history.push(`/${orgName}`) : history.push("/"))}
      notifications={notificationsData && notificationsData.notifications}
      onDismissNotifications={handleDismissNotifications}
    ></MainHeader>
  );
};

export default MainHeaderContainer;
